import getAxiosInstance from '../../../../../helpers/get_axios_instance'
import lrsAdapter from '../../../../../helpers/lrs_adapter'

export class TablaDescargaProcesadaEnStockService {
  static async getDataTablaDescargaProcesadaEnStock (fechaDesde, fechaHasta) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaDesde}", "fecha_hasta": "${fechaHasta}"}}`
    const promise = axios.get(`consulta_descarga_procesada_en_stock?r=${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}
